// `error` rows arrive unticked so a rejection can't reach IT Glue unnoticed, but stay
// tickable — a wrong rule must never silently drop a legitimate record.
export function rowState(bucket, index, verdicts = []) {
  const mine = verdicts.filter((v) => v.bucket === bucket && v.index === index);
  const level = mine.some((v) => v.level === 'error')
    ? 'error'
    : mine.length ? 'warning' : 'ok';
  return { level, reasons: mine.map((v) => v.reason), defaultChecked: level !== 'error' };
}
